module.exports = __webpack_public_path__ + "static/media/nav_03.a29ad9ae.svg";